const uploadStore = () => {
  return {
    multiFileList: [],
    processNumber: 3,
    promise: [],
    folderDownloadDialog: {
      show: false,
      exData: {}
    }
  }
}

const state = uploadStore()

const mutations = {
  SET_FOLDERDOWNLOADDIALOG(state, obj) {
    state.folderDownloadDialog.exData = obj.exData
    state.folderDownloadDialog.show = obj.show
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
